<template>
  <div class="article-detail-container" :style="{paddingTop: (isHarmony || isWxMini || isAlipayClient || isUCClient || isQuaReClient) ? '0px' : '56px'}">
    <open-app @openLinkApp="openLinkApp" :small-btn="true" v-show="!isHarmony && !isWxMini && !isAlipayClient && !isUCClient && !isQuaReClient" />
    <div class="article-detail-header"
         :style="{backgroundImage:topicDetail.cover_image?'url('+topicDetail.cover_image+')':'url(https://files.wondercv.com/community/article-bg.png)'}">
      <div class="masks">
        <div class="article-detail-nav flex-between">
          <span :class="isWxMini && needShare ? '' : 'iconfont iconchevron-left '" @click="pageBack"></span>
          <span class="nav-title">{{ topicDetail.name }}</span>
          <span class="iconfont iconfenxiang1" @click="changeWxState"></span>
        </div>
        <p class="article-detail-desc" v-if="topicDetail.description">{{ topicDetail.description }}</p>
        <div class="flex-start article-people">
          <div class="article-avatars flex-start">
            <template v-for="(item, index) in topicDetail.avatar_urls">
              <img :src="item" alt="" :key="index">
            </template>
          </div>
          <i class="iconfont iconmore-horizontal"></i>
          <span>{{ topicDetail.interactive_count }}人正在讨论</span>
          <!--          <span v-else>.......{{ topicDetail.interactive_count }}人正在讨论</span>-->
        </div>
      </div>
    </div>
    <div class="tab-container">
      <div class="tab_con">
        <w-tab :tab-list="tabList" :current-tab="currentTab" @changeTab="changeTab"></w-tab>
      </div>
    </div>
    <div class="scroll-container">
      <!--      <cube-scroll :data="[currentTab]" :options="options" @pulling-up="onPullingUp">-->
      <!--        <template v-if="currentTab === 0">-->
      <!--          <template v-for="(item, index) in articleListFromMe">-->
      <!--            <community-item :community-data="item" :key="index"></community-item>-->
      <!--          </template>-->
      <!--        </template>-->
      <!--        <template v-if="currentTab === 1">-->
      <!--          <template v-for="(item, index) in articleListFromHot">-->
      <!--            <community-item :community-data="item" :key="index"></community-item>-->
      <!--          </template>-->
      <!--        </template>-->
      <!--        <w-more-loading v-show="moreLoadingShow"/>-->
      <!--        <w-no-more v-show="noMoreShow && articleListFromMe.length>0 && currentTab===0"/>-->
      <!--        <w-no-more v-show="noMoreShow && articleListFromHot.length>0 && currentTab===1"/>-->
      <!--        <w-no-results text="暂无动态" v-show="articleListFromMe.length===0 && currentTab===0"></w-no-results>-->
      <!--        <w-no-results text="暂无热门" v-show="articleListFromHot.length===0 && currentTab===1"></w-no-results>-->
      <!--      </cube-scroll>-->
      <cube-scroll :data="[articleListFromMe]" :options="options" @scroll="fromMeScrollHandler"
                   :scrollEvents="['scroll']" @pulling-up="onPullingUp" ref="fromMeScroll" v-show="currentTab === 1">
        <template v-for="(item, index) in articleListFromMe">
          <community-item :community-data="item" :key="index" class="all-list"
                          @showBigImg="showBigImg"></community-item>
        </template>
        <w-more-loading v-show="moreLoadingShow"/>
        <!--        <w-no-more v-show="noMoreShow && articleListFromMe.length>0 && currentTab===0"/>-->
        <w-no-results text="暂无动态" v-show="articleListFromMe.length===0 && currentTab===1"></w-no-results>
      </cube-scroll>
      <cube-scroll :data="[articleListFromHot]" :options="options" @scroll="hotScrollHandler" @pulling-up="onPullingUp"
                   :scrollEvents="['scroll']" ref="hotScroll" v-show="currentTab === 0">
        <template v-for="(item, index) in articleListFromHot">
          <community-item :community-data="item" :key="index" class="hot-list"></community-item>
        </template>
        <w-more-loading v-show="moreLoadingShow"/>
        <!--        <w-no-more v-show="noMoreShow && articleListFromHot.length>0 && currentTab===1"/>-->
        <w-no-results text="暂无热门" v-show="articleListFromHot.length===0 && currentTab===0"></w-no-results>
      </cube-scroll>
    </div>
    <div class="community-add flex-center" v-show="!releaseState&&!bigImgState" @click="showRelease">
      <img src="https://files.wondercv.com/rn/bbs/tooptip.png" width="171" class="tooltip-image" v-show="showTooltip">
      <span class="iconfont iconplus2"></span>
    </div>
    <w-popup :state="releaseState">
      <release slot="content" :topicId="parseInt($route.params.topic_id)" :articeGroup="true" :state="releaseState"
               @closeRelease="closeRelease"></release>
    </w-popup>
    <div class="big_img_container">
      <big-img-popup :state="bigImgState">
        <big-img slot="content" :state="bigImgState" :imgIndex="imgIndex" :imgList="imgList"
                 :isDel='false' @closeBigImg="bigImgState=false"></big-img>
      </big-img-popup>
    </div>
    <w-share-wx :state="shareByWxState" @handleClose="changeWxState"/>
    <w-user-dialog/>
  </div>
</template>

<script>
  import WTab from '../../../components/global/w-tab'
  import communityItem from '../components/community-item'
  import WMoreLoading from '../../../components/global/w-more-loading'
  import WNoMore from '../../../components/global/w-no-more'
  import Release from '../components/release'
  import WPopup from '../../../components/global/w-popup'
  import WNoResults from '../../../components/global/w-no-result'
  import WShareWx from '../../../components/global/w-share-wx'
  import OpenApp from '../../../components/cv/open-app'
  import {envMixin, loginMixin, downloadAPPMixin} from '../../../assets/js/mixin/global'
  import {communityMixin} from '../../../assets/js/mixin/community'
  import BigImgPopup from '../components/big-img-popup'
  import BigImg from '../components/big-img'
  import db from "../../../assets/js/db";
  import {addClass, removeClass} from "../../../assets/js/dom";
  import WUserDialog from "../../../components/global/w-user-dialog.vue"
  export default {
    name: 'article-detail',
    mixins: [envMixin, communityMixin, loginMixin, downloadAPPMixin],
    data() {
      return {
        tabList: [{label: '热门'}, {label: '讨论'}],
        topicDetail: {},
        currentTab: 0,
        articleListFromMe: [],
        articleListFromHot: [],
        hotPage: 1,
        hotTotal: -1,
        mePage: 1,
        meTotal: -1,
        options: {
          pullUpLoad: true
        }, // scroll 事件配置
        releaseState: false,
        shareByWxState: false,
        fromMeScroll: 0,
        hotScroll: 0,
        bigImgState: false,
        imgIndex: 0,
        imgList: [],
        showTooltip: false
      }
    },
    async mounted() {
      this.changeNeedShareValue()
      await this.loginByWx()
      this.getAccountUser()
      this.getTopicDetail()
      this._getHotNews({refresh: true})
      this._getMeNews({refresh: true})
    },
    computed: {
      // 加载更多的loading
      moreLoadingShow() {
        return (this.currentTab === 0 && this.articleListFromMe.length < this.meTotal) || (this.currentTab === 1 && this.articleListFromHot.length < this.hotTotal)
      },
      // 没有更多的显示状态
      noMoreShow() {
        return (this.currentTab === 0 && this.articleListFromMe.length === this.meTotal) || (this.currentTab === 1 && this.articleListFromHot.length === this.hotTotal)
      }
    },
    watch: {
      mePage(value) {
        if (value === 2 && !db.ls.get('showTooltip')) {
          this.showTooltip = true
          db.ls.set('showTooltip', true)
          setTimeout(() => {
            this.showTooltip = false
          }, 5000)
        }
      },
      hotPage(value) {
        if (value === 2 && !db.ls.get('showTooltip')) {
          this.showTooltip = true
          db.ls.set('showTooltip', true)
          setTimeout(() => {
            this.showTooltip = false
          }, 5000)
        }
      },
      articleListFromHot() {
        this.$nextTick(() => {
          let els = document.querySelectorAll('.hot-list .community-item-desc')
          for (let i = 0; i < els.length; i++) {
            if (Number(getComputedStyle(els[i]).height.replace("px", "")) > 96) {
              addClass(document.querySelectorAll('.hot-list .more-item')[i], 'more-item-show')
            } else {
              removeClass(els[i], 'community-content-clip')
              removeClass(document.querySelectorAll('.hot-list .more-item')[i], 'more-item-show')
            }
          }
        })
      },
      articleListFromMe() {
        this.$nextTick(() => {
          let els = document.querySelectorAll('.all-list .community-item-desc')
          for (let i = 0; i < els.length; i++) {
            if (Number(getComputedStyle(els[i]).height.replace("px", "")) > 96) {
              addClass(els[i], 'community-content-clip')
              addClass(document.querySelectorAll('.all-list .more-item')[i], 'more-item-show')
            } else {
              removeClass(els[i], 'community-content-clip')
              removeClass(document.querySelectorAll('.all-list .more-item')[i], 'more-item-show')
            }
          }
        })
      },
      currentTab(value) {
        if (value == 1) {
          this.$nextTick(() => {
            let els = document.querySelectorAll('.hot-list .community-item-desc')
            for (let i = 0; i < els.length; i++) {
              removeClass(els[i], 'community-content-clip')
              removeClass(document.querySelectorAll('.hot-list .more-item')[i], 'more-item-show')
            }
            for (let i = 0; i < els.length; i++) {
              if (Number(getComputedStyle(els[i]).height.replace("px", "")) > 96) {
                addClass(els[i], 'community-content-clip')
                addClass(document.querySelectorAll('.hot-list .more-item')[i], 'more-item-show')
              } else {
                removeClass(els[i], 'community-content-clip')
                removeClass(document.querySelectorAll('.hot-list .more-item')[i], 'more-item-show')
              }
            }
          })
        } else {
          this.$nextTick(() => {
            let els = document.querySelectorAll('.all-list .community-item-desc')
            for (let i = 0; i < els.length; i++) {
              removeClass(els[i], 'community-content-clip')
              removeClass(document.querySelectorAll('.hot-list .more-item')[i], 'more-item-show')
            }
            for (let i = 0; i < els.length; i++) {
              if (Number(getComputedStyle(els[i]).height.replace("px", "")) > 96) {
                addClass(els[i], 'community-content-clip')
                addClass(document.querySelectorAll('.all-list .more-item')[i], 'more-item-show')
              } else {
                removeClass(els[i], 'community-content-clip')
                removeClass(document.querySelectorAll('.all-list .more-item')[i], 'more-item-show')
              }
            }
          })
        }
      }
    },
    components: {
      WTab,
      communityItem,
      WMoreLoading,
      WNoMore,
      Release,
      WPopup,
      WNoResults,
      WShareWx,
      BigImgPopup,
      BigImg,
      OpenApp,
      WUserDialog
    },
    methods: {
      // 打开APP
      openLinkApp(needReload) {
        let link = {
          ios: `https://www.wondercv.${process.env.VUE_APP_ENV === 'local' ? 'cn' : 'com'}/wondercv_app/open_app?type=other&id=${this.$route.params.topic_id}&open_type=topicDetail`,
          android: `android://h5/open?id=${this.$route.params.topic_id}&type=topicDetail`,
        }
        this.openApp(link, needReload)
      },
      hotScrollHandler({y}) {
        this.hotScroll = y
      },
      fromMeScrollHandler({y}) {
        this.fromMeScroll = y
      },
      // 改变微信分享的状态
      changeWxState() {
        this.shareByWxState = !this.shareByWxState
      },
      // 关闭发布弹窗
      closeRelease(state, obj, scroll) {
        this.releaseState = false
        if (state === 'success') {
          this.$createToast({
            txt: '发布成功',
            time: 2000,
            type: 'correct'
          }).show()
          this.articleListFromMe.unshift(obj)
          this.meTotal += 1
          if (scroll) {
            this.$refs.fromMeScroll.scrollTo(0, 0)
          }
        }
      },
      // 页面返回事件
      pageBack() {
        if (this.isWxMini && this.needShare) {
          this.$wechat.miniProgram.navigateBack()
        } else if (this.isWxMini) {
          this.$wechat.miniProgram.reLaunch({
            url: `/pages/community-list/community-list?url=${process.env.VUE_APP_HOST}/community`
          })
        } else {
          this.$router.back()
        }
      },
      // 切换tab
      changeTab(tab, index) {
        this.currentTab = index;
        if (index === 0) {
          this.$refs.hotScroll.scrollTo(0, this.hotScroll)
        } else {
          this.$refs.fromMeScroll.scrollTo(0, this.fromMeScroll)
        }
      },
      // 上拉加载
      onPullingUp() {
        if (this.currentTab === 1 && !this.noMoreShow) {
          this.mePage += 1
          this._getMeNews({refresh: false})
        } else if (this.currentTab === 0 && !this.noMoreShow) {
          this.hotPage += 1
          this._getHotNews({refresh: false})
        }
      },
      // 获取话题详情
      async getTopicDetail() {
        let {topic_id} = this.$route.params
        let res = await this.$api.bbs.getTopicDetail(topic_id)
        if (res.code === 1000) {
          this.topicDetail = res.data
        }
      },
      // 动态列表接口
      async _getMeNews({refresh}) {
        let {topic_id} = this.$route.params
        let res = await this.$api.bbs.getTopicMeArticles(topic_id, {
          page: this.mePage,
          size: 10
        })
        if (res.code === 1000) {
          this.articleListFromMe = refresh ? res.data.news_li : [...this.articleListFromMe, ...res.data.news_li]
          this.meTotal = res.data.total_count
          this.$nextTick(() => {
            let els = document.querySelectorAll('.all-list .community-item-desc')
            for (let i = 0; i < els.length; i++) {
              if (Number(getComputedStyle(els[i]).height.replace("px", "")) > 96) {
                addClass(document.querySelectorAll('.all-list .more-item')[i], 'more-item-show')
              } else {
                removeClass(els[i], 'community-content-clip')
                removeClass(document.querySelectorAll('.all-list .more-item')[i], 'more-item-show')
              }
            }
          })
        }
      },
      // 热门列表接口
      async _getHotNews({refresh}) {
        let {topic_id} = this.$route.params
        let res = await this.$api.bbs.getTopicHotArticles(topic_id, {
          page: this.hotPage,
          size: 10
        })
        if (res.code === 1000) {
          this.articleListFromHot = refresh ? res.data.news_li : [...this.articleListFromHot, ...res.data.news_li]
          this.hotTotal = res.data.total_count
          this.$nextTick(() => {
            let els = document.querySelectorAll('.hot-list .community-item-desc')
            for (let i = 0; i < els.length; i++) {
              if (Number(getComputedStyle(els[i]).height.replace("px", "")) > 96) {
                addClass(document.querySelectorAll('.hot-list .more-item')[i], 'more-item-show')
              } else {
                removeClass(els[i], 'community-content-clip')
                removeClass(document.querySelectorAll('.hot-list .more-item')[i], 'more-item-show')
              }
            }
          })
        }
      },
      showBigImg({index, list}) {
        console.log(index, list)
        console.log("列表")
        this.bigImgState = true
        this.imgIndex = index
        this.imgList = list
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../assets/scss/global/variable";
  @import "../../../assets/scss/global/mixin";

  .community-add {
    position: fixed;
    //bottom: 115px;
    bottom: 60px;
    right: 24px;
    width: 48px;
    height: 48px;
    border-radius: 50%;
    z-index: 199;
    //background-color: $color-light;
    background-image: linear-gradient(#ff9f79, #ff6644);
    box-shadow: 0px 6px 8px 0px rgba(255, 102, 68, 0.18);

    .iconfont {
      color: $color-light;
      font-weight: 600;
      font-size: 18px;
    }

    .tooltip-image {
      position: absolute;
      top: -65px;
      right: -5px;
      animation:downUp 1s ease-out infinite ;
    }
    @keyframes downUp {
      0%{
        transform: translateY(0px);
      }
      50%{
        transform: translateY(-6px);
      }
      100%{
        transform: translateY(0px);
      }
    }
  }

  .article-detail-container {
    position: relative;
    background-color: #f9f9f9;

    .article-detail-header {
      width: 100vw;
      height: 160px;
      //background-image: url("https://files.wondercv.com/community/article-bg.png");
      //background-size: 100vw 160px;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;

      .masks {
        padding: 0 24px;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.7);
        //position: absolute;
        //top: 0;
        //left: 0;

        .article-detail-nav {
          color: $color-light;
          height: 44px;
          margin-bottom: 24px;

          .iconchevron-left {
            font-size: 20px;
            font-weight: 600;
          }

          .iconfenxiang1 {
            font-size: 20px;
            font-weight: 500;
          }

          .nav-title {
            font-size: $font-size-large;
          }
        }

        .article-detail-desc {
          color: $color-light;
          line-height: 18px;
          font-size: $font-size-small;
          margin-bottom: 18px;
        }

        .article-people {
          color: $color-light;
          font-size: $font-size-small;

          .iconfont {
            color: #9c9c9c;
          }

          .article-avatars {
            img {
              width: 20px;
              height: 20px;
              border-radius: 50%;
              object-fit: contain;
              position: relative;
              background-color: $color-light;

              &:nth-child(1) {
                z-index: 6;
                margin-right: -12px;
              }

              &:nth-child(2) {
                z-index: 5;
                margin-right: -12px;
              }

              &:nth-child(3) {
                // margin-left: -12px;
                z-index: 4;
              }

              &:nth-child(4) {
                margin-left: -12px;
                z-index: 3;
              }
            }
          }
        }
      }
    }

    .tab-container {
      width: 100vw;
      height: auto;
      background-color: #fff;

      .tab_con {
        width: 120px;
        padding-left: 24px;
        padding-top: 18px;
        background-color: $color-light;

        /deep/ .tab-item {
          white-space: nowrap;
          margin-right: 32px;
        }

        /deep/ .active::after {
          margin-top: 10px;
        }
      }
    }

    .scroll-container {
      height: calc(calc(var(--vh, 1vh) * 100) - 205px);
      @include ipx-content-bottom(1px);
    }
  }
</style>
